import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Button from 'components/Button';
import {Description} from 'components/DescriptionList';
import Flex from 'components/Flex';
import OverflowTooltip from 'components/OverflowTooltip';
import AssetDownloadLink from 'components/AssetDownloadLink';

const FileNameDescription = ({
	isEditMode,
	isNewFile,
	assetId,
	fileName,
	onReplace,
}) => {
	const {t} = useTranslation();

	return (
		<Description title={t('form_file_name_colon')}>
			{isEditMode ? (
				<Flex align="top">
					<OverflowTooltip content={fileName}>
						<Box grow shrink mr="s" overflow="ellipsis">
							{/* Only enable file download if the file is already
							associated with the asset */}
							{isNewFile ? (
								fileName
							) : (
								<AssetDownloadLink assetId={assetId}>
									{fileName}
								</AssetDownloadLink>
							)}
						</Box>
					</OverflowTooltip>
					<Box>
						<Button
							size="small"
							variant="transparent"
							onClick={onReplace}
						>
							{t('actions_replace_file')}
						</Button>
					</Box>
				</Flex>
			) : (
				<OverflowTooltip content={fileName}>{fileName}</OverflowTooltip>
			)}
		</Description>
	);
};

export default FileNameDescription;

FileNameDescription.propTypes = {
	isEditMode: PropTypes.bool,
	isNewFile: PropTypes.bool,
	assetId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	fileName: PropTypes.string,
	onReplace: PropTypes.func,
};
